import { NgClass } from '@angular/common'
import { Component, inject, signal } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { Message } from '../models/message'
import { MessagingService } from '../services/messaging.service'

@Component({
  selector: 'app-messenger',
  templateUrl: './messenger.component.html',
  styleUrls: ['./messenger.component.scss'],
  imports: [NgClass, FontAwesomeModule],
})
export class MessengerComponent {
  private messaging = inject(MessagingService)

  messages = signal<Message[]>([])

  constructor() {
    this.messaging.subscribe((message: Message) => {
      this.addMessage(message)
      setTimeout(() => {
        this.updateMessage(message.id, 'displayed')
        setTimeout(() => {
          this.updateMessage(message.id, 'hidden')
          setTimeout(() => {
            this.removeMessage(message.id)
          }, 1000)
        }, 4000)
      }, 20)
    })
  }

  private addMessage(message: Message) {
    this.messages.update((existing) => {
      existing.forEach(({ sizeNumber }) => {
        message.position += sizeNumber + 10
      })
      return [...existing, message]
    })
  }

  private updateMessage(id: string, status: 'displayed' | 'hidden') {
    this.messages.update((existing) => {
      const messages = [...existing]
      const index = messages.findIndex((message) => message.id === id)
      if (index >= 0) {
        messages[index].animationStatus = status
      }
      return messages
    })
  }

  private removeMessage(id: string) {
    this.messages.update((existing) => {
      const messages = [...existing]
      const index = messages.findIndex((message) => message.id === id)
      if (index > -1) {
        messages.splice(index, 1)
      }
      return messages
    })
  }
}
